import { intranetConstants } from './intranet.constants'

const initialState = {
  clients: [],
  users: [],
  suppliers: [],
  error: null,
  loading: false,
  lastValidOrgNr: null,
}

export function intranet(state = initialState, action) {
  switch (action.type) {
    case intranetConstants.FETCH_CLIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        clients: action.clients,
      }
    case intranetConstants.FETCH_CLIENTS_LOADING:
      return {
        ...state,
        loading: true,
      }
    case intranetConstants.FETCH_CLIENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    case intranetConstants.SAVING_NEW_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case intranetConstants.SAVING_NEW_CLIENT:
      return {
        ...state,
        loading: true,
      }
    case intranetConstants.SAVING_NEW_CLIENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    /*SUPPLIER*/
    case intranetConstants.FETCH_SUPPLIER_SUCCESS:
      return {
        ...state,
        loading: false,
        suppliers: action.suppliers,
      }
    case intranetConstants.FETCH_SUPPLIER_LOADING:
      return {
        ...state,
        loading: true,
      }
    case intranetConstants.FETCH_SUPPLIER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    case intranetConstants.SAVING_NEW_SUPPLIER_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case intranetConstants.SAVING_NEW_SUPPLIER:
      return {
        ...state,
        loading: true,
      }
    case intranetConstants.SAVING_NEW_SUPPLIER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    case intranetConstants.FETCH_ORGANIZATION_SUCCESS:
      return {
        ...state,
        loading: false,
        lastValidOrgNr: action.orgnr,
      }
    case intranetConstants.FETCH_ORGANIZATION_LOADING:
      return {
        ...state,
        loading: true,
      }
    case intranetConstants.FETCH_ORGANIZATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    case intranetConstants.FETCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.users,
      }
    case intranetConstants.FETCH_USERS_LOADING:
      return {
        ...state,
        loading: true,
      }
    case intranetConstants.FETCH_USERS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    default:
      return state
  }
}
